import { useEffect, useState } from "react";

const groupInt = (intStr) => intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

function toDisplay(num) {
  if (num === "" || num === null || num === undefined) return "";
  const n = Number(num);
  if (Number.isNaN(n) || n === 0) return "";
  const [i, d] = String(num).split(".");
  const gi = groupInt((i || "0").replace(/^0+(?=\d)/, ""));
  return d !== undefined ? `${gi}.${d}` : gi;
}

// Text money input: type numbers freely (no spinners), auto-formats with thousands
// separators + up to 2 decimals as you type, and reports a plain Number via onChange.
export function MoneyInput({ value, onChange, testid, placeholder = "0", inputClassName }) {
  const [display, setDisplay] = useState(toDisplay(value));

  useEffect(() => {
    const cur = parseFloat(display.replace(/,/g, ""));
    const incoming = value === "" || value === null || value === undefined ? NaN : Number(value);
    if (Number.isNaN(incoming)) { if (display !== "") setDisplay(""); return; }
    if (Number.isNaN(cur) || cur !== incoming) setDisplay(toDisplay(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handle = (e) => {
    let raw = e.target.value.replace(/[^0-9.]/g, "");
    const firstDot = raw.indexOf(".");
    if (firstDot !== -1) raw = raw.slice(0, firstDot + 1) + raw.slice(firstDot + 1).replace(/\./g, "");
    let [intPart = "", decPart] = raw.split(".");
    intPart = intPart.replace(/^0+(?=\d)/, "");
    if (decPart !== undefined) decPart = decPart.slice(0, 2);
    const gi = groupInt(intPart);
    const disp = decPart !== undefined ? `${gi === "" ? "0" : gi}.${decPart}` : gi;
    setDisplay(disp);
    const numericStr = raw === "" || raw === "." ? "" : raw;
    onChange(numericStr === "" ? "" : parseFloat(numericStr));
  };

  const cls = inputClassName || "w-full rounded-md border border-[#E8E6E1] bg-white pl-7 pr-3.5 py-2.5 text-sm outline-none focus:border-[#8C9A86] focus:ring-2 focus:ring-[#8C9A86]/20";
  return (
    <div className="relative">
      <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-sm text-stone-400 pointer-events-none">$</span>
      <input type="text" inputMode="decimal" value={display} onChange={handle} placeholder={placeholder} data-testid={testid} className={cls} />
    </div>
  );
}
